import Layout, { LayoutContent, LayoutHeader } from '~/App/components/Layout'
import { ENVNAME } from '~/constants/environment'

interface ErrorPageProps {
  error?: Error
}

const ErrorPage = ({ error }: ErrorPageProps) => {
  return (
    <Layout>
      <LayoutHeader>
        <h1 className="text-xl font-medium">Unexpected error</h1>
      </LayoutHeader>
      <LayoutContent className="flex items-center justify-center text-center">
        {ENVNAME === 'local' && error ? (
          <pre className="overflow-auto text-left text-sm">{JSON.stringify(error, null, 2)}</pre>
        ) : (
          <p className="text-lg">Something went wrong. Please try again.</p>
        )}
      </LayoutContent>
    </Layout>
  )
}

export default ErrorPage
